<template>
  <div>
    <div class="wrapper-payment">
      <h4>{{ $t('graphs.tracking') }}</h4>
      <div v-for="(chart, index) in charts" :key="index" class="item-graph">
        <canvas :id="chart.id"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'TrackingGraph',
  // eslint-disable-next-line vue/require-prop-types
  props: ['period'],

  data() {
    return {
      charts: [
        {
          id: 'tracking',
          type: 'doughnut',
          options: [],
          labels: [],
          chart: [],
          update: false,
          title: this.$t('graphs.tracking'),
          colors: [
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
            'rgb(149, 117, 205)',
          ],
        },
      ],
    }
  },

  mounted() {
    this.$watch('period', this.fetch, { deep: true, immediate: true })
  },

  methods: {
    fetch() {
      this.$uiBlocker(
        this.$http
          .get('charts/tracking-data', {
            params: {
              from: this.period.gte,
              to: this.period.lte,
              division_id: this.currentDivision.id,
            },
          })
          .then(({ data }) => {
            this.draw(data)
          }),
        this.$el,
      )
    },

    draw(data) {
      // this.$refs.chart
      this.charts.forEach(chart => {
        let ctx = document.getElementById(chart.id).getContext('2d')

        this.getOptions(chart, data)

        let graph = chart.chart

        if (Object.keys(graph).length !== 0) {
          graph.destroy()
        }

        graph = new Chart(ctx, {
          type: chart.type,
          barPercentage: 12,
          data: {
            labels: chart.labels,
            datasets: [
              {
                data: chart.options,
                backgroundColor: chart.colors,
                borderWidth: 2,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        })

        chart.chart = graph
      })
    },
    getOptions(chart, data) {
      chart.labels = Object.keys(data)
      chart.options = Object.values(data)
    },
  },
}
</script>
